import React from 'react';
import {useTranslation} from "react-i18next";

interface Props {
    quantityInfo: {
        maxPermitted?: number;
        minPermitted?: number;
        chargeAbove?: number;
    };
    quantity: number;
    hideBadge?: true;
}

const ProductModifierGroupQuantityInfo = ({quantityInfo, quantity, hideBadge}: Props) => {
    const {t} = useTranslation();

    const getQuantityInfo = () => {
        if (quantityInfo.minPermitted && quantityInfo.maxPermitted && quantityInfo.maxPermitted === quantityInfo.minPermitted && quantityInfo.chargeAbove) {
            return t("modules.menu.field.quantity_rule_exact_with_free.title", {
                count: quantityInfo.minPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (quantityInfo.minPermitted && quantityInfo.maxPermitted && quantityInfo.chargeAbove) {
            return t("modules.menu.field.quantity_rule_range_with_free.title", {
                min: quantityInfo.minPermitted,
                max: quantityInfo.maxPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (!quantityInfo.minPermitted && quantityInfo.maxPermitted && quantityInfo.chargeAbove) {
            return t("modules.menu.field.quantity_rule_max_with_free.title", {
                max: quantityInfo.maxPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (!quantityInfo.maxPermitted && quantityInfo.minPermitted && quantityInfo.chargeAbove) {
            return t("modules.menu.field.quantity_rule_min_with_free.title", {
                min: quantityInfo.minPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (quantityInfo.maxPermitted && quantityInfo.minPermitted && quantityInfo.maxPermitted === quantityInfo.minPermitted && !quantityInfo.chargeAbove) {
            return t("modules.menu.field.quantity_rule_exact.title", {
                count: quantityInfo.minPermitted,
                free: quantityInfo.chargeAbove
            });
        }
        if (quantityInfo.minPermitted && quantityInfo.maxPermitted) {
            return t("modules.menu.field.quantity_rule_range.title", {
                min: quantityInfo.minPermitted,
                max: quantityInfo.maxPermitted,
            });
        }
        if (quantityInfo.minPermitted && !quantityInfo.maxPermitted) {
            return t("modules.menu.field.quantity_rule_min.title", {
                count: quantityInfo.minPermitted
            });
        }
        if (!quantityInfo.minPermitted && quantityInfo.maxPermitted) {
            return t("modules.menu.field.quantity_rule_max.title", {
                count: quantityInfo.maxPermitted
            });
        }
    };

    const getBadgeColor = () => {
        if (quantityInfo.minPermitted && quantityInfo.minPermitted > quantity) return "danger-light";

        return "success-light";
    }

    return (
        <div className="product-modifier-group-quantity-info d-flex align-items-start gap-2 justify-content-between">
            {!!(quantityInfo.minPermitted || quantityInfo.maxPermitted || quantityInfo.chargeAbove) && (
                <p className="text-muted mb-0 fw-normal">{getQuantityInfo()}</p>
            )}
            {!hideBadge && (
                <span className={`badge badge-${getBadgeColor()} ms-auto`}>
                    {`${t("modules.menu.field.default_quantity.title")}: ${quantity}`}
                </span>
            )}
        </div>
    )
}

export default ProductModifierGroupQuantityInfo;